import React, { useCallback, useEffect, useState, useRef } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex: 0 0 4px;
  width: 4px;
  height: 100%;
  background: gray;
  cursor: e-resize;
`

const Overlay = styled.div`
  display: ${({ show }) => show ? 'flex' : 'none'};
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: yellow;
  opacity: 0.3;
  z-index: 100000;
`

const ResizeHandle = ({ element }) => {
  const [resizing, setResizing] = useState(false)
  const [width, setWidth] = useState(0)
  const initialPosition = useRef(false)

  const handleMouseDown = useCallback(event => {
    initialPosition.current = event.pageX
    setResizing(true)
  }, [])

  useEffect(() => {
    if (resizing) {
      const moveListener = (event) => {
        if (event.buttons === 0) {
          setResizing(false)
        } else {
          const newWidth = width + (event.pageX - initialPosition.current)
          element.current.style.flexBasis = `${newWidth}px`
        }
      }
      const upListener = () => {
        setResizing(false)
        setWidth(element.current.offsetWidth)
      }
      window.addEventListener("mousemove", moveListener)
      window.addEventListener("mouseup", upListener)
      return () => {
        window.removeEventListener("mousemove", moveListener)
        window.removeEventListener("mouseup", upListener)
      }
    }
  }, [element, width, resizing])

  useEffect(() => {
    setWidth(element.current.offsetWidth)
  }, [element])

  return (
    <Container onMouseDown={handleMouseDown}>
      <Overlay show={resizing} />
    </Container>
  )
}

export default ResizeHandle